<template>
    <modal-generic v-bind="$attrs" />
</template>

<script>
export default {
    name: 'modal-auth-required',
};
</script>

<style scoped lang="less">
@import '~theme';

.modal-auth-required {
}
</style>
